import React from 'react';
import { X, LogOut, AlertTriangle } from 'lucide-react';
import ModalShell from './ModalShell';
import Button from './Button';

const LogoutModal = ({ isOpen, onClose, onConfirm, loading = false }) => {
  return (
    <ModalShell
      isOpen={isOpen}
      onClose={loading ? undefined : onClose}
      labelledBy="logout-modal-title"
      panelClassName="max-w-md"
    >
      <div
        className="w-full max-w-md overflow-hidden rounded-md border border-border bg-surface shadow-sm"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="logout-modal-title"
      >
        <div className="relative p-4 pb-3 sm:p-5 sm:pb-3">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="absolute right-3 top-3 rounded-md p-1 text-ink-tertiary transition-colors hover:bg-surface-muted hover:text-ink disabled:opacity-50"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="mb-3 flex items-center justify-center">
            <div className="flex h-10 w-10 items-center justify-center rounded-full border border-red-200 bg-red-50">
              <AlertTriangle className="h-5 w-5 text-red-600" />
            </div>
          </div>

          <h2
            id="logout-modal-title"
            className="mb-1 text-center text-base font-semibold text-ink"
          >
            Confirm logout
          </h2>
          <p className="text-center text-xs leading-relaxed text-ink-secondary">
            Are you sure you want to log out? You&apos;ll need to sign in again to access your
            account.
          </p>
        </div>

        <div className="flex gap-2 px-4 pb-4 sm:px-5 sm:pb-5">
          <Button
            type="button"
            variant="outline"
            size="lg"
            fullWidth
            className="!rounded-md"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="danger"
            size="lg"
            fullWidth
            className="!rounded-md"
            onClick={onConfirm}
            loading={loading}
            icon={LogOut}
          >
            Log out
          </Button>
        </div>
      </div>
    </ModalShell>
  );
};

export default LogoutModal;
